import { pushRoute } from '../../../../lib/router.js';

export const stepGeneralNewUrl = 'portfolio/new/step-general';
export const stepGeneralEditUrl = 'portfolio/edit/step-general';

export const stepDetailsNewUrl = 'portfolio/new/step-details';
export const stepDetailsEditUrl = 'portfolio/edit/step-details';

export const stepMilestonesNewUrl = 'portfolio/new/step-milestones';
export const stepMilestonesEditUrl = 'portfolio/edit/step-milestones';

export const stepLinkedFilesNewUrl = 'portfolio/new/step-linked-files';
export const stepLinkedFilesEditUrl = 'portfolio/edit/step-linked-files';

export const navigateToStepGeneral = (editing, portfolioId) =>
  editing
    ? pushRoute(stepGeneralEditUrl, { portfolioId })
    : pushRoute(stepGeneralNewUrl);

export const navigateToStepDetails = (editing, portfolioId) =>
  editing
    ? pushRoute(stepDetailsEditUrl, { portfolioId })
    : pushRoute(stepDetailsNewUrl);

export const navigateToStepMilestones = (editing, portfolioId) =>
  editing
    ? pushRoute(stepMilestonesEditUrl, { portfolioId })
    : pushRoute(stepMilestonesNewUrl);

export const navigateToStepLinkedFiles = (editing, portfolioId) =>
  editing
    ? pushRoute(stepLinkedFilesEditUrl, { portfolioId })
    : pushRoute(stepLinkedFilesNewUrl);

export const onReset = (editing, portfolioId, slug) =>
  navigateToStepGeneral(editing, portfolioId, slug);

export const onCreateUpdateCancel = (draftId, action, slug) => {
  if (draftId) {
    action(draftId).then(() => pushRoute('projects/index'));
  } else {
    pushRoute('projects/index');
  }
};
